import { render, staticRenderFns } from "./JoinContentItem.vue?vue&type=template&id=dabca090&scoped=true&"
import script from "./JoinContentItem.vue?vue&type=script&lang=js&"
export * from "./JoinContentItem.vue?vue&type=script&lang=js&"
import style0 from "./JoinContentItem.vue?vue&type=style&index=0&id=dabca090&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabca090",
  null
  
)

export default component.exports